import type { StackProps } from '@mui/material';
import { CustomizedAccordion } from '@rumblefish/ui/Rumblefish23Theme';
import { AccordionData } from './Faq.data';
import {
  AiKnowledgeManagementSolutionsFaqMainText,
  AiKnowledgeManagementSolutionsFaqGlowStack,
  AiKnowledgeManagementSolutionsFaqStyledStack,
  AiKnowledgeManagementSolutionsFaqDescriptionText,
  AiKnowledgeManagementSolutionsFaqStyledTextStack,
  AiKnowledgeManagementSolutionsLatestFaqSection,
  AiKnowledgeManagementSolutionsFaqStyledContentStack,
  AiKnowledgeManagementSolutionsFaqStyledAccordionStack,
} from './Faq.styles';

export const Faq = ({ ...props }: StackProps): React.ReactElement => {
  return (
    <AiKnowledgeManagementSolutionsLatestFaqSection width="normal">
      <AiKnowledgeManagementSolutionsFaqGlowStack />
      <AiKnowledgeManagementSolutionsFaqStyledStack {...props}>
        <AiKnowledgeManagementSolutionsFaqStyledContentStack>
          <AiKnowledgeManagementSolutionsFaqStyledTextStack>
            <AiKnowledgeManagementSolutionsFaqMainText variant="display_sm">
              Frequently Asked Questions
            </AiKnowledgeManagementSolutionsFaqMainText>
            <AiKnowledgeManagementSolutionsFaqDescriptionText variant="strong_400">
              Learn what you don’t know about AI-powered knowledge management
              systems.
            </AiKnowledgeManagementSolutionsFaqDescriptionText>
          </AiKnowledgeManagementSolutionsFaqStyledTextStack>
          <AiKnowledgeManagementSolutionsFaqStyledAccordionStack>
            <CustomizedAccordion data={AccordionData()} />
          </AiKnowledgeManagementSolutionsFaqStyledAccordionStack>
        </AiKnowledgeManagementSolutionsFaqStyledContentStack>
      </AiKnowledgeManagementSolutionsFaqStyledStack>
    </AiKnowledgeManagementSolutionsLatestFaqSection>
  );
};
